// extracted by mini-css-extract-plugin
export default {"publish-chapter-modal":"PublishChapterModal_publish-chapter-modal__LWm1G","header-wrapper":"PublishChapterModal_header-wrapper__Gz92x","content":"PublishChapterModal_content__skfZr"};